import { ApplicationRef, ChangeDetectorRef, Component, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MatDialogState } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessageService, ErrorData } from 'src/app/services/message/message.service';
import { menuOptions } from 'src/data/menu-options.data';
import { HomeComponent } from '../../home/home.component';
import { ImportServiceV2 } from 'src/app/services/imports/import.service-v2';
import { CommonService } from 'src/app/services/common/common.service';
import { InfoDialogTwoComponent } from 'src/app/shared/components/info-dialog-two/info-dialog-two.component';
import { scheduleAppRefresh } from 'src/app/shared/utils/refresh-view';

@Component({
  selector: 'spe-importar-csv-v2',
  templateUrl: './importar-csv-v2.component.html',
  styleUrls: ['./importar-csv-v2.component.scss'],
  standalone: false
})
// os tres arquivos de importação são bem repetitivos, talvez valha a pena criar um componente para isso
export class ImportarCsvV2Component implements OnInit {
  private dialogReference?: MatDialogRef<InfoDialogTwoComponent, any>;
  public message: string = '';
  public apiStatus: string | null = null;
  public alertMessage: string = 'Estamos processando seu arquivo. Aguarde';
  public alertTitle: string = 'Processando arquivo';
  public alertStatus: string | null = null;
  public showStepOne: boolean = true; // para testar os steps sem precisar fazer a importação em si, da para ir mudando essas variaveis
  public showStepTwo: boolean = false;
  public showStepSuccess: boolean = false;
  public showStepError: boolean = false;
  public showStepFail: boolean = false;
  public showStepAlert: boolean = false;
  public showStepCounters: boolean = false;
  public employees: number = 0;
  public benefits: number = 0;
  public errors: number = 0;
  public enableLoop: boolean = true;
  private idImportacao?: number;
  private subscriptions: Subscription[] = [];
  private idClientGroup = localStorage.getItem('idGrupoCliente');
  public errorsToShow: any[] = [];
  public sigla = localStorage.getItem('sigla');

  @ViewChild('createDialogTemplate') createDialogTemplate: TemplateRef<any> | undefined;

  constructor(
    public dialog: MatDialog,
    public readonly routerService: Router,
    private messageService: MessageService,
    private homeComponent: HomeComponent,
    public readonly importService: ImportServiceV2,
    public readonly commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private ngZone: NgZone
  ) {
    let extrasState = this.routerService.getCurrentNavigation()?.extras.state;
    if (extrasState != null) {
      let success = extrasState['success'];
      if (success != null && success === true) {
        this.showStepOne = false;
        this.showStepSuccess = true;
        this.alertTitle = 'Arquivo processado';
        this.showAlertMessage('O arquivo foi importado com sucesso.');
      }
    }
  }

  public importResume = () => {
    const url = this.routerService.serializeUrl(this.routerService.createUrlTree([`resumo-itens-importados`]));
    window.open(url, '_blank');
  };

  public filesDataForm = new FormGroup({
    importFile: new FormControl('')
  });

  get filesDataFormControl() {
    return this.filesDataForm.controls;
  }

  ngOnInit(): void {
    const messageSubscription = this.messageService.errorData$.subscribe((errorData: ErrorData) => {
      this.showMessage(errorData.errorMessage, errorData.isError);
    });
    this.subscriptions.push(messageSubscription);
    this.homeComponent.setNewVariables(
      'Importação de Arquivo CSV',
      "Neste módulo você pode importar o arquivo csv no formato ';', trazendo as informações da sua folha de pagamento e atualizando no site.",
      'importacao/importar-arquivo'
    );
    this.homeComponent.idleMenuContent = menuOptions[3].content;
    this.homeComponent.iconPath = 'assets/images/64_icon_earth_upload.png';
  }

  ngOnDestroy(): void {
    this.enableLoop = false;
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onChangeFile(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.filesDataForm.patchValue({
        importFile: file
      });
      document.getElementById('customFileLabel')!.innerHTML = file.name;
    }
  }

  public readonly openImportDialog = () => {
    let file: any = this.filesDataFormControl.importFile.value;
    let fileName: string = '';

    if (file != '') {
      fileName = file['name'];
    }
    fileName = fileName.toLowerCase();
    if (this.filesDataFormControl.importFile.value == '') {
      this.dialogReference = this.dialog.open(InfoDialogTwoComponent, {
        width: '332px',
        data: {
          title: 'Arquivo não aceito',
          message: 'Informe o arquivo que será importado.'
        }
      });
    } else if (fileName.length > 3 && fileName.slice(-3) != 'csv') {
      this.dialogReference = this.dialog.open(InfoDialogTwoComponent, {
        width: '332px',
        data: {
          title: 'Arquivo não aceito',
          message: 'Apenas arquivos com a extensão .csv são permitidos no upload.'
        }
      });
    } else {
      let file: any = this.filesDataFormControl.importFile.value;
      localStorage.setItem('fileName', file['name']);
      //this.showAlertMessage('Iniciando processamento do arquivo importado, aguarde...');
      const subscription = this.importService
        .iniciarProcessamento('S', this.filesDataFormControl.importFile.value)
        .subscribe({
          next: (data) => {
            this.showStepOne = false;
            this.showStepTwo = true;
            this.idImportacao = data;
            this.refreshView();
            this.importStatus(data);
          },
          error: (e) => {
            let errorMensagem: string = e.error.mensagem;

            if (errorMensagem.includes('Foram encontrados os seguintes erros na importação')) {
              let splitString = errorMensagem.split('<br><br>');

              for (let index = 1; index < splitString.length; index++) {
                if (splitString[index].includes('Corrija o arquivo para dar continuidade')) {
                  this.errorsToShow.push('&nbsp;');
                }

                this.errorsToShow.push(splitString[index]);
              }
            } else {
              this.errorsToShow.push(errorMensagem);
            }
            this.apiStatus = null;
            this.showStepOne = false;
            this.showStepAlert = true;
            this.refreshView();
          }
        });
      this.subscriptions.push(subscription);
    }
  };

  private readonly importStatus = (idImportacao: string) => {
    const subscription = this.importService.consultarStatusDeProcessamentoDaImportacao(idImportacao).subscribe({
      next: (data) => {
        this.showStepOne = false;
        this.showStepTwo = true;

        if (
          data.quantidadeEmpresas == 0 &&
          data.quantidadeEnderecos == 0 &&
          data.quantidadeFuncionarios == 0 &&
          data.quantidadeBeneficios == 0 &&
          data.quantidadeErros > 0 &&
          data.id == 1
        ) {
          this.showAlertMessage('Arquivo processado com erro. Por favor, tente novamente.');
        } else if (
          data.quantidadeEmpresas > 0 ||
          data.quantidadeEnderecos > 0 ||
          data.quantidadeFuncionarios > 0 ||
          data.quantidadeBeneficios > 0 ||
          data.id > 1
        ) {
          this.showAlertMessage('Processando o arquivo importado, aguarde...');
          this.showStepCounters = true;
          this.employees = data.quantidadeFuncionarios;
          this.benefits = data.quantidadeBeneficios;
          this.errors = data.quantidadeErros;
          if (data.id > 0) {
            this.showStepCounters = false;
            if (data.id == 9) {
              this.showStepTwo = false;
              this.showStepFail = true;
              this.showAlertMessage('Arquivo não processado por erros. Por favor, tente novamente.');
            } else {
              this.showAlertMessage('Finalizando, aguarde...');
              this.importProcess(idImportacao);
            }
          } else {
            setTimeout(() => {
              if (this.enableLoop) {
                this.importStatus(idImportacao);
              }
            }, 20000);
          }
        } else if (
          data.quantidadeEmpresas == 0 &&
          data.quantidadeEnderecos == 0 &&
          data.quantidadeFuncionarios == 0 &&
          data.quantidadeBeneficios == 0 &&
          data.quantidadeErros == 0 &&
          data.id == 0
        ) {
          setTimeout(() => {
            if (this.enableLoop) {
              this.importStatus(idImportacao);
            }
          }, 20000);
        }
        this.refreshView();
      },
      error: () => {
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  private readonly importProcess = (idImportacao: string) => {
    let body = { idImportacao: idImportacao, flagExtrairErroParaTratamento: 'N' };
    const subscription = this.importService.finalizarProcessamento(this.idClientGroup!, body).subscribe({
      next: (data) => {
        if (data == null) {
          this.concluirImportacao(idImportacao);
        } else {
          this.showStepTwo = false;
          this.showStepError = true;
          this.alertTitle = 'Validação de dados';
          this.showAlertMessage(
            'Foram encontrados inconsistências na importação do seu arquivo. Clique no botão abaixo para verificar e corrigir os dados.',
            true
          );
        }
        this.refreshView();
      },
      error: (e) => {
        this.showStepTwo = false;
        this.showStepFail = true;
        this.alertStatus = null;
        this.showMessage(
          `Erro na execução da importação. Contate a Central de Atendimento e informe o erro [4 ${e.error.mensagem}`
        );
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  private concluirImportacao = (idImportacao: string) => {
    const subscription = this.importService.concluirImportacao(this.idClientGroup!, idImportacao).subscribe({
      next: () => {
        this.consultarAndamento(idImportacao);
      },
      error: (e) => {
        this.showStepTwo = false;
        this.showStepAlert = true;
        let errorMensagem: string = e.error.mensagem;
        this.showAlertMessage('Erro na geração da importação.');
        this.errorsToShow.push(`Contate a Central de Atendimento e informe o erro [5 ${errorMensagem}`);
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  private consultarAndamento = (idImportacao: string) => {
    const subscription = this.importService.consultarAndamentoConclusao(this.idClientGroup!, idImportacao).subscribe({
      next: (d) => {
        if (d.importacaoControle.flagStatus == 'C') {
          this.showStepTwo = false;
          this.showStepSuccess = true;
          this.alertTitle = 'Arquivo processado';
          this.showAlertMessage('O arquivo foi importado com sucesso.');
        } else if (d.importacaoControle.flagStatus == 'E' || d.importacaoControle.flagStatus == 'F') {
          this.showStepTwo = false;
          this.showStepAlert = true;
          this.showMessage(`${d.importacaoControle.codigoDoErro} - ${d.importacaoControle.descricaoDoErro}`);
          this.commonService.autoScroll();
        } else if (d.importacaoControle.flagStatus == 'P') {
          setTimeout(() => {
            if (this.enableLoop) {
              this.consultarAndamento(idImportacao);
            }
          }, 20000);
        } else {
          this.showStepTwo = false;
          this.showStepAlert = true;
          this.showMessage(`Algo deu errado ao concluir a importação`);
          this.commonService.autoScroll();
        }
        this.refreshView();
      },
      error: (e) => {
        this.showStepAlert = true;
        this.showStepTwo = false;
        this.commonService.autoScroll();
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  private readonly confirmDialogConfig = (body: string): Object => {
    const data = {
      title: 'Importar arquivo',
      component: this.createDialogTemplate,
      confirmAction: this.closeDialog,
      body: body,
      confirm: 'Localizar arquivo',
      file: this.filesDataFormControl.importFile
    };
    return { panelClass: 'full-bleed-dialog', width: '600px', data: data };
  };

  private readonly closeDialog = () => {
    if (this.dialogReference && this.dialogReference.getState() === MatDialogState.OPEN) {
      this.dialogReference.afterClosed().subscribe((result) => {
        this.filesDataForm.patchValue({
          importFile: result
        });
        document.getElementById('customFileLabel')!.innerHTML = result.name;
      });
      this.dialogReference.close();
    }
  };

  public readonly goTo = () => {
    this.routerService.navigate([`home/importacao/importar-arquivo/verificar-dados-importados/${this.idImportacao}`], {
      queryParams: { tipo: 'csv' }
    });
  };

  private readonly showMessage = (text: string = '', errorMessage: boolean = false) => {
    this.apiStatus = errorMessage ? 'error' : 'success';
    this.message = text;
  };

  private readonly showAlertMessage = (text: string = '', errorMessage: boolean = false) => {
    this.alertStatus = errorMessage ? 'error' : 'success';
    this.alertMessage = text;
  };

  public novaImportacao = () => {
    this.showStepOne = true;
    this.showStepAlert = false;
    this.showStepError = false;
    this.showStepTwo = false;
    this.showStepSuccess = false;
    this.showStepFail = false;
    this.showStepCounters = false;
    this.refreshView();
  };

  private refreshView(): void {
    this.cdr.detectChanges();
    scheduleAppRefresh(this.appRef, this.ngZone);
  }
}
